import { addFollow } from '@eventbrite/follow-organizer-ebui';
import React from 'react';
import { NavDirections } from '../../SimpleCarousel/types';
import { OrganizerCard } from './OrganizerCard';

export const OrganizerList = addFollow(
    ({
        organizers,
        setDisabledNav,
        children,
    }: {
        organizers: string[];
        setDisabledNav: React.Dispatch<
            React.SetStateAction<NavDirections | undefined>
        >;
        children: React.ReactChildren;
    }) => {
        const childrenLength = organizers.length;
        const organizerCards = organizers.map((organizerId, slideNumber) => {
            return (
                <OrganizerCard
                    key={slideNumber}
                    slideNumber={slideNumber}
                    organizerId={organizerId}
                    childrenLength={childrenLength}
                    setDisabledNav={setDisabledNav}
                />
            );
        });

        return (
            <>
                {organizerCards}
                {children}
            </>
        );
    },
);
